import { localizationModuleLocs } from '@cm/ui/localize';
import { spFulfillmentVoucherLocs } from 'libs/clients/src/comptia/fulfillment-vouchers/fulfillment-voucher.locs';
import { spSuspendGrantableCertsLocs } from 'libs/clients/src/comptia/manual-suspend-periods/components/sp-suspend-grantable-certs/sp-suspend-grantable-certs.locs';
import { spVoucherFeeBatchLocDefs } from 'libs/clients/src/comptia/vouchers/voucher-fee.locs';
import { spCmUiModuleLocs } from 'libs/cm/ui/src/lib/cm-ui-module.locs';
import { spCredentialAgreementLoc } from 'libs/core/localization/src/data/agreement.loc';
import { spSharedCandidateAffiliationLocs } from 'libs/feature/affiliation/src/components/candidate-affiliation-form/candidate-affiliation-form.sp-locs';
import { spSharedPageLocs } from 'libs/shared/pages/src/library.locs';
import { spAuditLocs } from 'libs/sp/feature/audit/src/lib/audit-locs';
import { spCandidateOtherAchievementLocs } from 'libs/sp/feature/candidate/other-achievements/src/lib/candidate-other-achievement.locs';
import { spCandidateSearchFormLocs } from 'libs/sp/feature/candidate/search/src/lib/components/candidate-search-form/candidate-search-form.locs';
import { spCandidateSearchDefaultLocs } from 'libs/sp/feature/candidate/search/src/lib/components/candidate-search-results-table/candidate-search-results-table.locs';
import { spCandidateProgramFeesLocs } from 'libs/sp/feature/candidates/src/lib/candidate-outlet/program-history/program-fees/program-fees.locs';
import { spCandidateAffiliationLocs } from 'libs/sp/feature/candidates/src/lib/candidate-outlet/summary/candidate-affiliations/form/candidate-affiliations-form.locs';
import { spCandidatesModuleLocs } from 'libs/sp/feature/candidates/src/lib/candidates.module.locs';
import { spCandExamModuleLocs } from 'libs/sp/feature/candidates/src/lib/modules/exams/candidate-exams.module.locs';
import { spCandidateSecurityModuleLocs } from 'libs/sp/feature/candidates/src/lib/modules/security/candidate-security.module.locs';
import { spCandidateHistoryModuleLocs } from 'libs/sp/feature/candidates/src/lib/modules/shared/candidate-history/candidate-history.locs';
import { spAchievementModuleLocs } from 'libs/sp/feature/catalogs/achievements/src/lib/achievements.module.locs';
import { badgingModuleLocs } from 'libs/sp/feature/catalogs/badging/src/lib/badging.module.locs';
import { spBenefitsCatalogModuleLocs } from 'libs/sp/feature/catalogs/benefits/src/lib/sp-benefits-catalog.module.locs';
import { certsCatalogModuleLocs } from 'libs/sp/feature/catalogs/certs/src/lib/certs-catalog.module.locs';
import { spEmailsModuleLocs } from 'libs/sp/feature/catalogs/emails/src/lib/emails.module.locs';
import { spExamsCatalogModuleLocs } from 'libs/sp/feature/catalogs/exams/src/lib/exams.module.locs';
import { spFulfillmentsCatalogModuleLocs } from 'libs/sp/feature/catalogs/fulfillments/src/lib/fulfillments-catalog.module.locs';
import { fulfillmentsModuleLocs } from 'libs/sp/feature/catalogs/fulfillments/src/lib/fulfillments.module.locs';
import { spOtherAchievementCatalogLocs } from 'libs/sp/feature/catalogs/other-achievements/src/lib/other-achievement-catalog.locs';
import { otherRequirementsModuleLocs } from 'libs/sp/feature/catalogs/other-requirements/src/lib/other-requirements.module.locs';
import { spOtherRequirementCatalogLocs } from 'libs/sp/feature/catalogs/other-requirements/src/lib/other-requirements/other-requirements.locs';
import { spDashboardReportsModuleLocs } from 'libs/sp/feature/dashboard-reports/src/lib/dashboard-reports.module.locs';
import { spCandidatePurchaseHistoryLocs } from 'libs/sp/feature/ecommerce/src/lib/candidate/components/purchase-history/purchase-history.locs';
import { spHomeModuleLocs } from 'libs/sp/feature/home/src/lib/home.module.locs';
import { loginModuleLocs } from 'libs/sp/feature/login/src/lib/login/login.module.locs';
import { ssoModuleLocs } from 'libs/sp/feature/login/src/lib/sso/sso.module.locs';
import { reportsModuleLocs } from 'libs/sp/feature/reports/src/lib/reports.module.locs';
import { spSettingsTokenCountLocs } from 'libs/sp/feature/settings/src/lib/benefits/token-count.locs';
import { spSettingsScoreReportDelayModuleLocs } from 'libs/sp/feature/settings/src/lib/score-report-delay/score-report-delay-module.locs';
import { settingsModuleLocs } from 'libs/sp/feature/settings/src/lib/settings.module.locs';
import { spTaggingAddDomainModalLocs } from 'libs/sp/feature/settings/src/lib/tagging/add-domain-modal/add-domain-modal.locs';
import { spTaggingDomainsLocs } from 'libs/sp/feature/settings/src/lib/tagging/tagging-domains.locs';
import { spTagItemModalLocs } from 'libs/sp/feature/settings/src/lib/tagging/tagging-items/tag-item-modal/tag-item-modal.locs';
import { spTaggedItemsLocs } from 'libs/sp/feature/settings/src/lib/tagging/tagging-items/tagged-items/tagged-items.locs';
import { spTaggingItemsLocs } from 'libs/sp/feature/settings/src/lib/tagging/tagging-items/tagging-items.locs';
import { spUntaggedItemsLocs } from 'libs/sp/feature/settings/src/lib/tagging/tagging-items/untagged-items/untagged-items.locs';
import { supportModuleLocs } from 'libs/sp/feature/support/src/lib/support.module.locs';
import { spToolsModuleLocs } from 'libs/sp/feature/tools/src/lib/tools.module.locs';
import { spUserModuleLocs } from 'libs/sp/feature/users/src/lib/users.module.locs';
import { spCriteriaRulesModuleLocs } from 'libs/sp/shared/criteria-rules/src/lib/criteria-rules.module.locs';
import { spDataManagerLibLocs } from 'libs/sp/shared/data-management/src/sp-data-management.locs';
import { spNavigationLocs } from 'libs/sp/ui/src/lib/modules/navigation/data/sp-nav-locs';
import { spUiModuleLocs } from 'libs/sp/ui/src/lib/sp-ui.module.locs';

export const preloadedSP = {
	...spNavigationLocs,
};
export const allSP = {
	...badgingModuleLocs,
	...spBenefitsCatalogModuleLocs,
	...certsCatalogModuleLocs,
	...fulfillmentsModuleLocs,
	...loginModuleLocs,
	...otherRequirementsModuleLocs,
	...reportsModuleLocs,
	...settingsModuleLocs,
	...spAchievementModuleLocs,
	...spCandExamModuleLocs,
	...spCandidateAffiliationLocs,
	...spCandidateSearchDefaultLocs,
	...spCandidateSearchFormLocs,
	...spCandidatesModuleLocs,
	...spCandidateSecurityModuleLocs,
	...spCandidatesModuleLocs,
	...spCredentialAgreementLoc,
	...spDataManagerLibLocs,
	...spEmailsModuleLocs,
	...spExamsCatalogModuleLocs,
	...spFulfillmentsCatalogModuleLocs,
	...spHomeModuleLocs,
	...spCandidateOtherAchievementLocs,
	...spOtherRequirementCatalogLocs,
	...spOtherAchievementCatalogLocs,
	...spSettingsTokenCountLocs,
	...spSharedCandidateAffiliationLocs,
	...spSharedPageLocs,
	...spTagItemModalLocs,
	...spTaggedItemsLocs,
	...spTaggingAddDomainModalLocs,
	...spTaggingDomainsLocs,
	...spTaggingItemsLocs,
	...spToolsModuleLocs,
	...spUntaggedItemsLocs,
	...spUserModuleLocs,
	...ssoModuleLocs,
	...supportModuleLocs,
	...spCmUiModuleLocs,
	...spCriteriaRulesModuleLocs,
	...spUiModuleLocs,
	...settingsModuleLocs,
	...localizationModuleLocs,
	...spSettingsScoreReportDelayModuleLocs,
	...spCandidatePurchaseHistoryLocs,
	...spAuditLocs,
	...spDashboardReportsModuleLocs,
	...spVoucherFeeBatchLocDefs,
	...spCandidateProgramFeesLocs,
	...spFulfillmentVoucherLocs,
	...spCandidateHistoryModuleLocs,
	...spSuspendGrantableCertsLocs,
};
